import React from 'react';
import { connect } from 'react-redux';
import { __ } from '../../../helpers/TranslationService';
import { IContactPageReducer } from '../../../reducers/contactPage';
import { IContactFormReducer } from '../../../interfaces/IContactForm';
import { deleteContactFormData } from '../../../actions/contactFormActions';
import { Advisor } from '../components/Advisor';

interface StateProps {
    contactPage: IContactPageReducer;
    contactForm: IContactFormReducer;
}

interface DispatchProps {
    deleteContactFormData(channel: string): void;
}

interface Props {
    contactPage: IContactPageReducer;
}

type IProps = StateProps & DispatchProps;

export class AdvisorListClass extends React.Component<IProps, any> {
    cleanModal = () => this.props.deleteContactFormData('advisorModal');

    render() {
        const { contactPage } = this.props;
        return (
            <div className="advisorListContainer">
                <h3 className="contactSubtitle">
                    {__('contactpage_mobilesite_subtext', 'dreamlines')}
                </h3>
                <div className="advisorList">
                    {contactPage.advisors.map((advisor, index) => (
                        <Advisor key={index} advisor={advisor} cleanModal={this.cleanModal} />
                    ))}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: StateProps) => state;
const mapDispatchToProps = { deleteContactFormData };

export const AdvisorList = connect<StateProps, DispatchProps, any>(
    mapStateToProps,
    mapDispatchToProps,
)(AdvisorListClass);

export default AdvisorList;
